import { render, staticRenderFns } from "./InspectionDetailModal.vue?vue&type=template&id=0640dadb&"
import script from "./InspectionDetailModal.vue?vue&type=script&lang=js&"
export * from "./InspectionDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./InspectionDetailModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports